export default function SkillsSection() {
  const designTools = [
    { name: 'CorelDRAW', level: 95, icon: 'ri-pencil-ruler-2-line' },
    { name: 'Adobe Illustrator', level: 90, icon: 'ri-brush-line' },
    { name: 'Photoshop', level: 88, icon: 'ri-image-edit-line' }
  ];

  const competencies = [
    { icon: 'ri-palette-line', title: 'Brand Identity', description: 'Creating cohesive visual systems' },
    { icon: 'ri-layout-line', title: 'Layout Design', description: 'Balanced and engaging compositions' },
    { icon: 'ri-pantone-line', title: 'Color Theory', description: 'Strategic color applications' },
    { icon: 'ri-font-size', title: 'Typography', description: 'Expressive type treatments' },
    { icon: 'ri-printer-line', title: 'Print Design', description: 'Print-ready professional materials' },
    { icon: 'ri-box-3-line', title: 'Packaging', description: 'Eye-catching product packaging' }
  ];

  return (
    <section id="skills" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h4 className="text-yellow-400 font-semibold text-lg mb-4">
            <a href="#skills" className="hover:text-yellow-300 transition-colors">My Expertise</a>
          </h4>
          <h3 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Skills & <span className="text-yellow-400">Competencies</span>
          </h3>
          <p className="text-gray-300 text-lg max-w-3xl mx-auto">
            Mastering industry-leading tools and design principles to deliver exceptional results for every project.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16">
          {/* Design Tools */}
          <div>
            <h4 className="text-2xl font-bold text-white mb-8">Design Tools</h4>
            <div className="space-y-6">
              {designTools.map((tool, index) => (
                <div key={index}>
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center space-x-3">
                      <div className="w-8 h-8 flex items-center justify-center">
                        <i className={`${tool.icon} text-yellow-400 text-xl`}></i>
                      </div>
                      <span className="text-white font-semibold">{tool.name}</span>
                    </div>
                    <span className="text-yellow-400 font-semibold">{tool.level}%</span>
                  </div>
                  <div className="w-full bg-gray-800 rounded-full h-2 overflow-hidden">
                    <div 
                      className="bg-gradient-to-r from-yellow-400 to-yellow-600 h-full rounded-full transition-all duration-1000 ease-out"
                      style={{ width: `${tool.level}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Core Competencies */}
          <div>
            <h4 className="text-2xl font-bold text-white mb-8">Core Competencies</h4>
            <div className="grid grid-cols-2 gap-4">
              {competencies.map((competency, index) => (
                <div 
                  key={index}
                  className="bg-gray-900 p-6 rounded-lg border border-gray-800 hover:border-yellow-400/50 transition-all duration-300 hover:transform hover:scale-105"
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-yellow-400/20 rounded-lg mb-4">
                    <i className={`${competency.icon} text-yellow-400 text-2xl`}></i>
                  </div>
                  <h5 className="text-white font-semibold mb-2">{competency.title}</h5>
                  <p className="text-gray-400 text-sm">{competency.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
